import appConfig from "../config";
import axiosInstance from './axiosConfig';
import axios from "axios";
import {IMatch} from "../Interfaces/IMatch";
import {ISqd} from "../Interfaces/ISqd";
import {IUsrSqdCmpEdt} from "../Interfaces/IUsrSqdCmpEdt";

class AxiosServices {

    static baseURL: string = appConfig.apiURL;
    static usrApiURL: string = `${appConfig.apiURL}/user`
    private static usrbetApiURL: string = `${appConfig.apiURL}/usrbet`

    static async validateToken(token: string) {
        console.log(`token = ${token}`);
        const baseURL = `${this.usrApiURL}/check-email?token=${token}`;
        try {
            const response = await axiosInstance.post(baseURL);
            return {data: response, error: null};
        } catch (error: unknown) {
            let errorMessage: string;
            if (axios.isAxiosError(error)) {
                errorMessage = error.response ? error.response.data : error.message;
            } else {
                errorMessage = (error as Error).message;
            }
            return {data: null, error: errorMessage};
        }
    }

    static async GetCurrentUser(storedToken: string) {
        const baseURL = `${this.usrApiURL}/getUser?token=${storedToken}`;
        console.log(baseURL)
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                    return res.data;
                }
            );
    }

    static getUsers(callback: Function) {
        axiosInstance.get("https://jsonplaceholder.typicode.com/users")
            .then((data) => {
                console.log(data);
                callback(data?.data);
            });
    }

    static RegisterAccount(values: any) {
        const baseURL = `${this.usrApiURL}/register`;
        return axiosInstance.post(baseURL, values);
    }

    static async AccountLogin(values: any) {
        console.log('AccountLogin');
        const baseURL = `${this.usrApiURL}/login`;
        console.log(`values = ${JSON.stringify(values)}`);
        return await axiosInstance.post(baseURL, values)
    }

    static async ValidateEmail(token: string) {
        const baseURL = `${this.usrApiURL}/check-email?token=${token}`;
        const res = await axiosInstance.get(baseURL);
        console.log(res);
        return res;
    }

    static async getCpmEdt(callback: Function) {
        const baseURL = `${appConfig.apiURL}/competition`;
        await axiosInstance.get(baseURL)
            .then((res) => {
                    console.log(res);
                    callback(res.data);
                }
            );
    }

static async fakeAuthToken(callback: Function): Promise<void> {
        const baseURL = `${this.usrApiURL}/token`;
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                    console.log('result', res.data.data);
                    await callback(res.data.data);
                }
            );
    }

    static async getGroups(callback: Function, competition: number): Promise<void> {
        const baseURL = `${appConfig.apiURL}/groups?cmpEdt=${competition}`;
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                console.log('result', res.data);
                await callback(res.data);
            });
    }

    static async groupStandingsByUserBets(cmpEdt: number, grp: string): Promise<Array<{
        usr_idt: number;
        cmpedt_idt: number;
        grp_cod: string;
        rang: number;
        team_idt: number;
        team: string;
        mp: number;
        w: number;
        d: number;
        l: number;
        gf: number;
        ga: number;
        gd: number;
        pts: number;
    }>> {
        const baseURL = `${appConfig.apiURL}/groups/standings/bets?cmpEdt=${cmpEdt}&grp=${encodeURIComponent(grp)}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async groupStandings(cmpEdt: number, grp: string): Promise<Array<{
        cmpedt_idt: number;
        grp_cod: string;
        rang: number;
        team_idt: number;
        team: string;
        mp: number;
        w: number;
        d: number;
        l: number;
        gf: number;
        ga: number;
        gd: number;
        pts: number;
    }>> {
        const baseURL = `${appConfig.apiURL}/groups/standings?cmpEdt=${cmpEdt}&grp=${encodeURIComponent(grp)}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static matchesApiURL: string = `${appConfig.apiURL}/matches`
    static matchScoreApiURL: string = `${appConfig.apiURL}/matchscore`
    static chatApiURL: string = `${appConfig.apiURL}/chat`

    static async chatListChannels(): Promise<Array<{
        idt: number;
        usrLow_idt: number;
        usrHigh_idt: number;
        initiator_idt: number;
        state: 'PENDING' | 'ACCEPTED' | 'REFUSED' | 'BLOCKED';
        decidedAt: string | null;
        usrLow_username: string;
        usrHigh_username: string;
        unreadCount: number | string;
        lastBody: string | null;
        lastAt: string | null;
    }>> {
        const res = await axiosInstance.get(`${this.chatApiURL}/channels`);
        return res.data;
    }

    static async chatListPendingRequests(): Promise<Array<{
        idt: number;
        usrLow_idt: number;
        usrHigh_idt: number;
        initiator_idt: number;
        initiator_username: string;
        state: 'PENDING';
        createdAt: string;
    }>> {
        const res = await axiosInstance.get(`${this.chatApiURL}/requests/pending`);
        return res.data;
    }

    static async chatSendRequest(to_usr_idt: number) {
        const res = await axiosInstance.post(`${this.chatApiURL}/requests`, {to_usr_idt});
        return res.data;
    }

    static async chatAccept(channel_idt: number) {
        const res = await axiosInstance.post(`${this.chatApiURL}/requests/${channel_idt}/accept`);
        return res.data;
    }

    static async chatRefuse(channel_idt: number) {
        const res = await axiosInstance.post(`${this.chatApiURL}/requests/${channel_idt}/refuse`);
        return res.data;
    }

    static async chatBlock(channel_idt: number) {
        const res = await axiosInstance.post(`${this.chatApiURL}/requests/${channel_idt}/block`);
        return res.data;
    }

    static async chatListMessages(channel_idt: number, afterIso?: string): Promise<Array<{
        idt: number;
        channel_idt: number;
        sender_idt: number;
        body: string;
        createdAt: string;
        readAt: string | null;
    }>> {
        const params = afterIso ? `?after=${encodeURIComponent(afterIso)}` : '';
        const res = await axiosInstance.get(`${this.chatApiURL}/channels/${channel_idt}/messages${params}`);
        return res.data;
    }

    static async chatSendMessage(channel_idt: number, body: string) {
        const res = await axiosInstance.post(`${this.chatApiURL}/channels/${channel_idt}/messages`, {body});
        return res.data;
    }

    static async chatMarkRead(channel_idt: number) {
        const res = await axiosInstance.post(`${this.chatApiURL}/channels/${channel_idt}/read`);
        return res.data;
    }

    static async getMatches(callback: Function, competition: number): Promise<void> {
        const baseURL = `${this.matchesApiURL}?cmpEdt=${competition}`;
        console.log('getMatches', baseURL)
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                    await callback(res.data);
                }
            );
    }

    static async adminUpdateMatchMeta(idt: number, data: {num?: number; hre?: string; dte?: string; finished?: boolean}) {
        const baseURL = `${this.matchesApiURL}/${idt}`;
        const res = await axiosInstance.put(baseURL, data);
        return res.data;
    }

    static async getCmpEdtTeams(cmpEdt: number): Promise<Array<{idt: number; nom: string; nomLong: string}>> {
        const res = await axiosInstance.get(`${this.matchesApiURL}/teams?cmpEdt=${cmpEdt}`);
        return res.data;
    }

    static async adminUpdateMatchTeams(idt: number, data: {teamIdtDom?: number | null; teamIdtExt?: number | null}) {
        const baseURL = `${this.matchesApiURL}/${idt}/teams`;
        const res = await axiosInstance.put(baseURL, data);
        return res.data;
    }

    static async adminUpdateMatchExpected(idt: number, data: {
        expectedDomNum?: number | null;
        expectedExtNum?: number | null;
        expectedDomKind?: 'W' | 'L';
        expectedExtKind?: 'W' | 'L';
    }) {
        const baseURL = `${this.matchesApiURL}/${idt}/expected`;
        const res = await axiosInstance.put(baseURL, data);
        return res.data;
    }

    static async adminUpdateMatchThirdPlace(idt: number, isThirdPlace: boolean) {
        const baseURL = `${this.matchesApiURL}/${idt}/third-place`;
        const res = await axiosInstance.put(baseURL, {isThirdPlace});
        return res.data;
    }

    static async getStades(cmpEdt: number): Promise<Array<{idt: number; nom: string; nomLong: string; capacite: number; ville: string}>> {
        const res = await axiosInstance.get(`${this.matchesApiURL}/stades?cmpEdt=${cmpEdt}`);
        return res.data;
    }

    static async adminUpdateMatchStade(idt: number, stadeIdt: number) {
        const baseURL = `${this.matchesApiURL}/${idt}/stade`;
        const res = await axiosInstance.put(baseURL, {stadeIdt});
        return res.data;
    }

    // --- MatchAtt (forecast knock-out match templates) ---
    static matchAttApiURL: string = `${appConfig.apiURL}/matchatt`;

    static async matchAttListByCmpEdt(cmpEdt: number): Promise<Array<{
        matchatt_idt: number;
        match_idt: number;
        match_num: number;
        fifa_label: string | null;
        slot_idt: number | null;
        dom_ext: 'D' | 'E' | null;
        slot_type: 'G' | 'M' | '3' | null;
        valeur: string | null;
        numero: number | null;
    }>> {
        const res = await axiosInstance.get(`${this.matchAttApiURL}?cmpEdt=${cmpEdt}`);
        return res.data;
    }

    static async matchAttCreate(match_idt: number, slots: Array<{DomExt: 'D' | 'E'; Type: 'G' | 'M' | '3'; Valeur: string; Numero: number}> = [], fifa_label?: string | null) {
        const body: any = {match_idt, slots};
        if (fifa_label !== undefined) body.fifa_label = fifa_label;
        const res = await axiosInstance.post(this.matchAttApiURL, body);
        return res.data as {matchatt_idt: number};
    }

    static async matchAttSetFifaLabel(matchatt_idt: number, fifa_label: string | null) {
        const res = await axiosInstance.put(`${this.matchAttApiURL}/${matchatt_idt}/fifa-label`, {fifa_label});
        return res.data;
    }

    static async matchAttDelete(matchatt_idt: number) {
        const res = await axiosInstance.delete(`${this.matchAttApiURL}/${matchatt_idt}`);
        return res.data;
    }

    static async matchAttAddSlot(matchatt_idt: number, slot: {DomExt: 'D' | 'E'; Type: 'G' | 'M' | '3'; Valeur: string; Numero: number}) {
        const res = await axiosInstance.post(`${this.matchAttApiURL}/${matchatt_idt}/slots`, slot);
        return res.data;
    }

    static async matchAttRemoveSlot(slot_idt: number) {
        const res = await axiosInstance.delete(`${this.matchAttApiURL}/slots/${slot_idt}`);
        return res.data;
    }

    // FIFA "best thirds" ranking, surfaced from v_meilleurs_troisiemes
    static async getBestThirds(cmpEdt: number): Promise<Array<{
        cmpedt_idt: number;
        rang: number;
        grp_cod: string;
        team_idt: number;
        team: string;
        mp: number;
        tous_joues: number;
        w: number; d: number; l: number;
        gf: number; ga: number; gd: number; pts: number;
    }>> {
        const res = await axiosInstance.get(`${this.matchesApiURL}/best-thirds?cmpEdt=${cmpEdt}`);
        return res.data;
    }

    static async bracket3rdsResolve(cmpEdt: number, qualifiers: string): Promise<{
        qualifiers: string;
        assignments: Array<{match_label: string; third_grp: string}>;
    }> {
        const res = await axiosInstance.get(`${appConfig.apiURL}/bracket3rds/resolve?cmpEdt=${cmpEdt}&qualifiers=${encodeURIComponent(qualifiers)}`);
        return res.data;
    }

    // Round-of-16 pairings "vainqueur de groupe vs 3ème qualifié"
    // for the FIFA best-thirds format, surfaced from v_third_opponents.
    static async getThirdOpponents(cmpEdt: number): Promise<Array<{
        cmpedt_idt: number;
        groupes: string;
        match_label: string;
        winner_grp: string;
        winner_team_idt: number | null;
        winner_team: string | null;
        third_grp: string;
        third_team_idt: number;
        third_team: string;
    }>> {
        const res = await axiosInstance.get(`${appConfig.apiURL}/bracket3rds/third-opponents?cmpEdt=${cmpEdt}`);
        return res.data;
    }

    static async UpdateMatch(match: IMatch, matchteam_idt: number, value: any) {
        const baseURL = `${this.matchScoreApiURL}`;
        console.log('UpdateMatch : ', baseURL)
        const values = {
            matchteam_idt: matchteam_idt,
            score: value,
        }
        return await axiosInstance.post(baseURL, values)
    }

    static async SaveUserBet(matchteam_idt: number, score: number, random: boolean = false) {
        const baseURL = `${this.usrbetApiURL}`;
        return await axiosInstance.post(baseURL, {matchteam_idt, score, random});
    }

    static async DeleteMatchScores(match_idt: number) {
        const baseURL = `${this.matchScoreApiURL}/match/${match_idt}`;
        return await axiosInstance.delete(baseURL);
    }

    static async getMatchScore(callback: Function, matchteam_idt?: number): Promise<void> {
        const baseURL = matchteam_idt !== undefined
            ? `${this.matchScoreApiURL}?matchteam_idt=${matchteam_idt}`
            : this.matchScoreApiURL;
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                await callback(res.data);
            });
    }

    static async getClassement(callback: Function, competition: number): Promise<void> {
        const baseURL = `${this.usrApiURL}/classement?cmpEdt_Idt=${competition}`;
        console.log(baseURL)
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                    await callback(res.data);
                }
            );
    }

    static async getUserBets(callback: Function, competition: number, usr: string | undefined, match?: number): Promise<void> {
        if (usr === undefined) return;
        let baseURL = `${this.usrbetApiURL}?cmpedt_idt=${competition}&username=${usr}`;
        if (match) baseURL += `&match=${match}`;
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                    await callback(res.data);
                }
            );
    }

    static async getPointsByMatch(cmpEdt: number): Promise<Array<{
        cmpedt_idt: number;
        match_num: number;
        usr_idt: number;
        parieur: string;
        total: number | string;
    }>> {
        const baseURL = `${this.matchesApiURL}/points-by-match?cmpEdt=${cmpEdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getLeaderboard(cmpEdt: number): Promise<Array<{
        cmpedt_idt: number;
        usr_idt: number;
        parieur: string;
        total: number | string;
    }>> {
        const baseURL = `${this.matchesApiURL}/leaderboard?cmpEdt=${cmpEdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getBetsByMatch(cmpEdt: number): Promise<Array<{
        match_num: number;
        usr_idt: number;
        parieur: string;
        score_dom: number | null;
        score_ext: number | null;
    }>> {
        const baseURL = `${this.matchesApiURL}/bets-by-match?cmpEdt=${cmpEdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getMatchDays(callback: Function, competition: number): Promise<void> {
        const baseURL = `${this.matchesApiURL}/match-days?cmpedt_idt=${competition}`;
        console.log(baseURL)
        return await axiosInstance.get(baseURL)
            .then(async (res) => {
                    await callback(res.data);
                }
            );
    }

    /**
     * Réinitialise le mot de passe à partir d'un token de reset.
     * Attend que le backend invalide le token (one-shot).
     */
    static async resetPassword(token: string, newPassword: string) {
        const res = await axios.post(`${this.usrApiURL}/reset-password`, {
            token,
            password: newPassword,

        });
        return res.data; // { ok: true } ou { error: string }
    }

    static sqdApiURL: string = `${appConfig.apiURL}/sqd`;
    static usrSqdApiURL: string = `${appConfig.apiURL}/usrSqdCmpEdt`;

    static async listSquads(): Promise<ISqd[]> {
        const res = await axiosInstance.get(this.sqdApiURL);
        return res.data;
    }

    static async createSquad(cmpEdtIdt: number, lib: string): Promise<ISqd> {
        const res = await axiosInstance.post(this.sqdApiURL, {Lib: lib, cmpEdt_idt: cmpEdtIdt});
        return res.data;
    }

    static async joinSquad(token: string): Promise<IUsrSqdCmpEdt> {
        const baseURL = `${this.usrSqdApiURL}/join`;
        const res = await axiosInstance.post(baseURL, {token});
        return res.data;
    }

    static async getSquadById(sqdIdt: number): Promise<ISqd> {
        const baseURL = `${this.sqdApiURL}/${sqdIdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getSquadByCode(code: string): Promise<ISqd> {
        const baseURL = `${this.sqdApiURL}/by-code/${encodeURIComponent(code)}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getSquadMembers(sqdIdt: number): Promise<IUsrSqdCmpEdt[]> {
        const baseURL = `${this.usrSqdApiURL}/by-sqd/${sqdIdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getSquadsForCmpEdt(cmpEdtIdt: number): Promise<IUsrSqdCmpEdt[]> {
        const baseURL = `${this.usrSqdApiURL}/by-cmpedt/${cmpEdtIdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getMySquads(usrIdt: number): Promise<IUsrSqdCmpEdt[]> {
        const baseURL = `${this.usrSqdApiURL}/by-usr/${usrIdt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async getMyProfile() {
        const baseURL = `${this.usrApiURL}/me`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async updateMyProfile(data: {Title?: string; firstName?: string; lastName?: string; username?: string; hideName?: boolean; hideEmail?: boolean; randomBet?: boolean}) {
        const baseURL = `${this.usrApiURL}/me`;
        const res = await axiosInstance.put(baseURL, data);
        return res.data;
    }

    static async listUsers() {
        const baseURL = `${this.usrApiURL}/list`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async adminUpdateUser(idt: number, data: {role?: string; email?: string}) {
        const baseURL = `${this.usrApiURL}/${idt}`;
        const res = await axiosInstance.put(baseURL, data);
        return res.data;
    }

    static async adminDeleteUser(idt: number) {
        const baseURL = `${this.usrApiURL}/${idt}`;
        const res = await axiosInstance.delete(baseURL);
        return res.data;
    }

    static async adminResendVerification(idt: number) {
        const baseURL = `${this.usrApiURL}/${idt}/resend-verification`;
        const res = await axiosInstance.post(baseURL);
        return res.data;
    }

    static async adminGetUserEmail(idt: number): Promise<{email: string}> {
        const baseURL = `${this.usrApiURL}/${idt}/email`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async createReg(cmpEdt_idt: number, lib: string): Promise<{Idt: number; idt?: number; Lib: string; Token: string}> {
        const baseURL = `${appConfig.apiURL}/reg`;
        const res = await axiosInstance.post(baseURL, {cmpEdt_idt, lib});
        return res.data;
    }

    static async listMyRegs(): Promise<Array<{idt: number; Lib: string; Token: string; CmpEdt?: {idt: number}}>> {
        const baseURL = `${appConfig.apiURL}/reg/mine`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async joinReg(token: string): Promise<any> {
        const baseURL = `${appConfig.apiURL}/reg/join`;
        const res = await axiosInstance.post(baseURL, {token});
        return res.data;
    }

    static async joinGlobalReg(cmpEdt_idt: number): Promise<any> {
        const baseURL = `${appConfig.apiURL}/reg/global/${cmpEdt_idt}`;
        const res = await axiosInstance.post(baseURL);
        return res.data;
    }

    static async listCmpEdtBets(cmpEdt_idt: number): Promise<Array<{
        idt: number;
        Cod: string;
        Lib: string;
        allowedTeams: Array<{idt: number; nom: string}>;
        userAnswer: string | null;
    }>> {
        const baseURL = `${appConfig.apiURL}/cmpedtbet?cmpEdt=${cmpEdt_idt}`;
        const res = await axiosInstance.get(baseURL);
        return res.data;
    }

    static async saveCmpEdtBetAnswer(cmpedtbet_idt: number, result: string) {
        const baseURL = `${appConfig.apiURL}/cmpedtbet/answer`;
        const res = await axiosInstance.post(baseURL, {cmpedtbet_idt, result});
        return res.data;
    }

    static async changePassword(currentPassword: string, newPassword: string) {
        const baseURL = `${this.usrApiURL}/change-password`;
        const res = await axiosInstance.post(baseURL, {currentPassword, newPassword});
        return res.data;
    }

    static async forgotPassword(email: string) {
        const baseURL = `${this.usrApiURL}/forgot-password`;
        try {
            const res = await axios.post(baseURL, {email});
            return {data: res.data, error: null};
        } catch (error: unknown) {
            let errorMessage: string;
            if (axios.isAxiosError(error)) {
                errorMessage = error.response ? error.response.data : error.message;
            } else {
                errorMessage = (error as Error).message;
            }
            return {data: null, error: errorMessage};
        }
    }
}

export default AxiosServices;
